import React, { useEffect, useState } from 'react';

/* En el laboratorio el panel queda abierto todo el día: cuando se publica una versión nueva, el navegador sigue con la
   anterior hasta recargar. Cada 5 minutos (y al volver a la pestaña) se compara el archivo principal publicado con el
   que está corriendo; si cambió, aparece una barra para actualizar con un clic. */
const actual = () => {
  const s = Array.from(document.scripts).map((x) => x.src).find((src) => /\/static\/js\/main\.[a-f0-9]+\.js/.test(src));
  return s ? s.match(/main\.[a-f0-9]+\.js/)[0] : null;
};

export default function AvisoVersion() {
  const [hayNueva, setHayNueva] = useState(false);

  useEffect(() => {
    const corriendo = actual();
    if (!corriendo) return undefined;   // en desarrollo (npm start) no hay archivo con huella
    let cancelado = false;
    const revisar = async () => {
      try {
        const r = await fetch('/index.html?v=' + Date.now(), { cache: 'no-store' });
        const html = await r.text();
        const publicado = (html.match(/main\.[a-f0-9]+\.js/) || [])[0];
        if (!cancelado && publicado && publicado !== corriendo) setHayNueva(true);
      } catch (e) { /* sin red: se vuelve a intentar luego */ }
    };
    const id = setInterval(revisar, 5 * 60 * 1000);
    const alVolver = () => { if (document.visibilityState === 'visible') revisar(); };
    document.addEventListener('visibilitychange', alVolver);
    return () => { cancelado = true; clearInterval(id); document.removeEventListener('visibilitychange', alVolver); };
  }, []);

  if (!hayNueva) return null;
  return (
    <div className="sym-version" role="status">
      <span>Hay una versión nueva del sistema.</span>
      <button type="button" className="btn btn-sm btn-light" onClick={() => window.location.reload()}>Actualizar</button>
    </div>
  );
}
